import {IRoutableModule} from '../../router/routing.infra';
import {vjHistoryRouteLoader} from './vj-history.loader';
import {VjHistoryRouteView} from './vj-history.view';

export default {
    loader: vjHistoryRouteLoader,
    Component: VjHistoryRouteView,
    storeAs: 'vjHistoryStore'
} as IRoutableModule;
